import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from "./Popover";
export const Tooltip = (props) => {
    var _a;
    return (_jsx(Popover, Object.assign({}, props, { content: () => (_jsx("div", { className: "max-w-[352px] font-body-medium", children: props.content })), withArrow: true, withPadding: true, initialFocus: false, invertColors: true, withShadow: false, triggerAction: (_a = props.triggerAction) !== null && _a !== void 0 ? _a : "hover" })));
};
//# sourceMappingURL=Tooltip.js.map